import type { BoggleChallengeBonusId } from '~/boggle/config/bonuses/types'

/** Shared challenge bonus pool for Race / Reboot / Sprint catalog challenges. */
export const BOGGLE_CHALLENGE_ALLOWED_BONUS_IDS = [
  'no-repeats',
  'double-letter',
  'anchor-letter',
  'vowel-scarcity',
  'shotgun',
  'longshot',
  'palindrome',
] as const satisfies readonly BoggleChallengeBonusId[]
